import React from 'react'
import bg1 from '../../assets/images/authentication.jpg'
import { Link } from 'react-router-dom'
import BackToHome from '../../components/back-to-home'

export default function PageLogin2() {
  return (
    <>
    <BackToHome/>
    <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-primary"></div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-7">
                    <div className="login_page bg-white rounded p-4">
                        <div className="text-center">
                            <h4 className="mb-3">Login / Signin</h4>  
                        </div>
                        <form className="login-form">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="mb-3">
                                        <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="mb-3">
                                        <label className="form-label">Password <span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Password" required=""/>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <p className="float-end position-relative" style={{zIndex: '99'}}><Link to="/page-forgot-password-2" className="text-dark fw-bold">Forgot password ?</Link></p>
                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault">Remember me</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-12 mb-0">
                                    <button className="btn btn-primary w-100">Sign in</button>
                                </div>

                                <div className="col-lg-12 mt-4 text-center">
                                    <h6>Or Login With</h6>
                                </div>

                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-sm-6 mt-4">
                                            <div className="d-grid">
                                                <Link to="#" className="btn btn-blue"><i className="mdi mdi-facebook"></i> Facebook</Link>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 mt-4">
                                            <div className="d-grid">
                                                <Link to="#" className="btn btn-light border"><i className="mdi mdi-google"></i> Google</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 text-center">
                                    <p className="mb-0 mt-4"><small className="text-dark me-2">Don't have an account ?</small> <Link to="/page-signup-2" className="text-dark fw-bold">Sign Up</Link></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div> 
            </div>
        </div>
    </section>
    </>
  )
}
